export enum SituationType {
  OPEN = '1',
  PAID = '2',
  CANCELED = '3',
  TITLE_TRANSFERRED = '5'
}

export enum StatusGroup {
  PAYABLE = '1',
  PAID = '2'
}
